/**
 * Apple IAP feature flag.
 *
 * Read strictly from build-time env (`import.meta.env.VITE_IAP_APPLE_ENABLED`),
 * never from `process.env` and never user-controllable at runtime.
 *
 * IMPORTANT (P0 iOS): the flag is fail-OPEN by default. A missing `.env` on a
 * developer machine previously compiled the iOS bundle with the flag `false`,
 * so StoreKit never ran and the paywall showed "The store is unavailable right
 * now". Vite also pins this value at build time (see `vite.config.ts` define).
 * Only an explicit "false" / "0" / "off" / "no" disables Apple IAP.
 */
const DISABLED_VALUES = ["false", "0", "off", "no"];

export const IAP_APPLE_ENABLED: boolean = (() => {
  try {
    const raw = (import.meta as any)?.env?.VITE_IAP_APPLE_ENABLED;
    if (typeof raw !== "string" || raw.trim() === "") return true;
    return !DISABLED_VALUES.includes(raw.trim().toLowerCase());
  } catch {
    return true;
  }
})();

/**
 * Grep-able build marker (`IAP_APPLE_FLAG=true` / `...=false`) injected by Vite.
 * `npm run ios:sync` asserts this literal inside the compiled native bundle.
 */
// Direct (non optional-chained) access so Vite's `define` can statically
// replace it with the literal marker string at build time.
export const IAP_FLAG_BUILD_MARKER: string =
  (import.meta.env.VITE_IAP_FLAG_MARKER as string) ?? "IAP_APPLE_FLAG=unknown";


// Side effect at module scope keeps the literal alive through minification and
// exposes it for on-device inspection. No secrets, no user data.
try {
  (globalThis as any).__MBLEARN_IAP_FLAG__ = IAP_FLAG_BUILD_MARKER;
} catch {
  /* noop */
}

export function isAppleIapEnabled(): boolean {
  return IAP_APPLE_ENABLED === true;
}



